<template>
    <span v-if="this.findStockPrice(this.stock)">
        <router-link target="_blank" name="stoke-view" :to="{ path: '/stock/view', query: { id: this.findStockPrice(this.stock).code }}">
            {{ this.$helper.formatPrice(this.findStockPrice(this.stock).market_price) }}
        </router-link>
    </span>
</template>

<script>

import { computed } from 'vue';

export default {
    name: 'stock-current-price',
    props: {
        row:{type: Object},
        stockList: {type: Object},
    },

    methods: {
        findStockPrice(stockId){
            let row;
            this.stockList.forEach(e => {
                if (e.stock_id == stockId) {
                    row = e;
                }
            });
            return row;
        }
    },
    setup(props) {
        const stock = computed(() => {
        const { row } = props;
        const parsedRule = row?.rule ? JSON.parse(row.rule) : {};
        const firstStock = parsedRule?.stock?.[0];

        if (typeof firstStock === 'object' && firstStock !== null) {
            return firstStock.code;
        }

        return firstStock;
        });
        return {stock};
    }
}
</script>

